module.exports = __webpack_public_path__ + "media/images/clickworker_com/2fa_step_2-51d774279738e200541f5dce9bb3b7c9.png";